import React from 'react';
import { Link } from 'react-router-dom';
import '../../CSS/Blog.css';
import '../../CSS/App.css';

const LibraryBlog = () => {
  return (
    <div className="blog-container">
      <Link to="/blog" className="blog-back-link">← Back to Blog</Link>

      <p className="blog-post-title">Library Management System</p>
      <p className="blog-meta">Java · SQL · REST API</p>

      <div className="blog-body">
        <p>
          This was a group project I made for school. My part of the project was mostly the database and the
          Java API that interacted with it. Basically, I wanted the rest of my group to be able to work with
          all of the library data without having to know or care about the SQL happening underneath.
        </p>

        <h2>The Database</h2>
        <p>
          I designed the database around books, members, loans, and staff.
        </p>
        <p>
          The relationships took me a few tries to get right, especially with books and loans. A single book
          can have multiple physical copies, and each one needs to be checked out separately, so I couldn't
          just treat a book title as one thing.
        </p>
        <p>
          I also wrote stored procedures for common operations like checking out books, returning them, and
          calculating overdue fines. That way most of the database logic stayed inside the database instead of
          being scattered throughout the Java code.
        </p>

        <h2>The API</h2>
        <p>
          On top of that I made a Java API using JDBC. It had endpoints for things like searching for books,
          adding records, changing member information, and looking at loan history.
        </p>
        <p>
          I tried to keep it pretty simple. There wasn't really a reason to add a bunch of stuff nobody on the
          team was going to use.
        </p>
        <p>
          Something that ended up being harder than I expected was error handling. It's easy to make an API
          work when everything goes correctly. The more annoying part is figuring out what should happen when
          someone tries to check out a book that isn't available or sends something the API doesn't expect.
        </p>

        <h2>What I Learned</h2>
        <p>
          Working on the backend for a group project made me think about APIs differently. I knew how my
          database worked, but the other people on my team shouldn't need to understand my database just to
          use it.
        </p>
        <p>
          They just needed to send something to the API and get a predictable response back.
        </p>
        <p>
          It made me realize that an API is kind of a communication layer between two sides of a program.
          Making that communication simple and predictable ended up being just as important as getting the
          database itself to work.
        </p>
      </div>
    </div>
  );
};

export default LibraryBlog;
